// src/Lightbox.tsx

import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface LightBoxProps {
	open: boolean;
	imageSrc: string;
	onClose: () => void;
}

const LightBox: React.FC<LightBoxProps> = ({ open, imageSrc, onClose }) => {
	return (
		<Dialog
			sx={{ zIndex: 1500 }}
			open={open}
			onClose={onClose}
			maxWidth="md"
			fullWidth
		>
			<IconButton
				onClick={onClose}
				style={{
					position: 'absolute',
					right: 8,
					top: 8,
					color: 'white',
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				}}
			>
				<CloseIcon />
			</IconButton>
			<DialogContent
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: 0,
				}}
			>
				<img src={imageSrc} alt="Lightbox" style={{ maxHeight: '80vh', maxWidth: '100%' }} />
			</DialogContent>
		</Dialog>
	);
};
export default LightBox;

export function useLightBox(image: string) {
	const [lightboxOpen, set_lightboxOpen] = useState(false);

	const handleOpenLightbox = () => {
		set_lightboxOpen(true);
	};

	const handleCloseLightbox = () => {
		set_lightboxOpen(false);
	};

	const lightBoxEle = lightboxOpen ?
		<LightBox
			open={lightboxOpen}
			imageSrc={image}
			onClose={handleCloseLightbox}
		/>
		: null;

	return [lightBoxEle, set_lightboxOpen] as const;
}